<template>
  <div class="container-fluid mt-4" dir="rtl">
    
    <!-- 1. لوحة التحكم (تختفي عند الطباعة) -->
    <div class="card shadow-sm mb-4 border-top-dark no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-dark fw-bold">
          <i class="fas fa-th ms-2"></i> طباعة النتيجة الرقمية (الجريدة)
        </h5>
      </div>
      <div class="card-body">
        <div class="row g-3 align-items-end">
          <div class="col-md-4">
            <label class="form-label fw-bold">تصفية بالقطاع / الإدارة</label>
            <select v-model="filters.sector" class="form-select">
              <option value="">-- الكل --</option>
              <option value="1">قطاع العريش</option>
              <option value="2">قطاع بئر العبد</option>
            </select>
          </div>
          <div class="col-md-4">
            <button @click="fetchResults" class="btn btn-dark w-100 fw-bold" :disabled="loading">
              <span v-if="loading" class="spinner-border spinner-border-sm ms-2"></span>
              تجهيز الكشوف
            </button>
          </div>
          <div class="col-md-4" v-if="schoolsData.length > 0">
             <button @click="printResult" class="btn btn-outline-dark w-100 fw-bold">
               <i class="fas fa-print ms-2"></i> طباعة
             </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. منطقة الطباعة -->
    <div id="printMe" v-if="schoolsData.length > 0">
      
      <!-- حلقة تكرار لكل مدرسة -->
      <div 
        v-for="(school, index) in schoolsData" 
        :key="school.id" 
        class="school-sheet"
      >
        
        <!-- ترويسة المدرسة -->
        <header class="report-header mb-4 border-bottom border-2 border-dark pb-2">
          <div class="row text-center align-items-center">
            <div class="col-4 text-start">
              <h6 class="fw-bold mb-1">محافظة شمال سيناء</h6>
              <h6 class="fw-bold mb-0">لجنة النظام والمراقبة</h6>
            </div>
            <div class="col-4">
              <h3 class="fw-bold text-decoration-underline">النتيجة الرقمية 2026</h3>
              <div class="mt-2 badge bg-dark text-white fs-6 border border-dark">
                {{ school.name }}
              </div>
            </div>
            <div class="col-4 text-end">
              <h6 class="fw-bold mb-1">قطاع: {{ school.sector }}</h6>
              <h6 class="fw-bold mb-0">المجموع الكلي: 280</h6>
            </div>
          </div>
        </header>

        <!-- جسم الصفحة: تقسيم الطلاب حسب النوع -->
        
        <!-- 1. الطلاب النظاميون -->
        <div v-if="school.regular.length > 0">
            <h6 class="category-title">طلاب مقيدون (نظامي)</h6>
            <div class="result-grid">
                <div v-for="student in school.regular" :key="student.seat" class="student-box" :class="getScoreClass(student)">
                    <div class="seat-num">{{ student.seat }}</div>
                    <div class="total-score">{{ student.total }}</div>
                </div>
            </div>
        </div>

        <!-- 2. طلاب المنازل -->
        <div v-if="school.homes.length > 0" class="mt-4">
            <h6 class="category-title bg-secondary text-white">طلاب المنازل</h6>
            <div class="result-grid">
                <div v-for="student in school.homes" :key="student.seat" class="student-box border-secondary" :class="getScoreClass(student)">
                    <div class="seat-num bg-secondary text-white">{{ student.seat }}</div>
                    <div class="total-score">{{ student.total }}</div>
                </div>
            </div>
        </div>

        <!-- 3. طلاب الدمج -->
        <div v-if="school.damg.length > 0" class="mt-4">
            <h6 class="category-title bg-info text-dark">طلاب الدمج التعليمي</h6>
            <div class="result-grid">
                <div v-for="student in school.damg" :key="student.seat" class="student-box border-info" :class="getScoreClass(student)">
                    <div class="seat-num bg-info text-dark">{{ student.seat }}</div>
                    <div class="total-score">{{ student.total }}</div>
                </div>
            </div>
        </div>

        <!-- تذييل المدرسة -->
        <div class="school-footer mt-5 pt-2 border-top border-dark break-avoid">
            <div class="d-flex justify-content-between px-5 fw-bold small">
                <span>عدد المتقدمين: {{ school.stats.total }}</span>
                <span>ناجح: {{ school.stats.pass }}</span>
                <span>دور ثان: {{ school.stats.fail }}</span>
                <span>النسبة: {{ school.stats.percentage }}%</span>
            </div>
            <div class="text-center mt-4">
                <p class="mb-0">رئيس لجنة النظام والمراقبة</p>
                <p>.............................</p>
            </div>
        </div>

        <!-- فاصل صفحات -->
        <div class="page-break"></div>

      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
export default {
  name: "DigitalResultGazette",
  data() {
    return {
      loading: false,
      filters: { sector: '' },
      schoolsData: []
    };
  },
  methods: {
   async fetchResults() {
  this.loading = true;
  try {
    // الاتصال بالباك اند
    const res = await api.get('/control/digital-gazette', { params: this.filters });
    const rawSchools = res.data; // البيانات القادمة من لارافيل

    // معالجة البيانات (تقسيم الطلاب) كما هي في كود الفيو السابق
    this.schoolsData = rawSchools.map(school => {
        return {
            ...school,
            regular: school.students.filter(s => s.type == 1), // نظامي
            homes: school.students.filter(s => s.type == 2),   // منازل
            damg: school.students.filter(s => s.type == 3)     // دمج
        };
    });

  } catch (e) {
    console.error(e);
    alert("حدث خطأ في جلب البيانات");
  } finally {
    this.loading = false;
  }
},

    getScoreClass(student) {
        if (student.status === 'fail' || student.total < 140) {
            return 'failed-box'; // كلاس للراسب
        }
        return '';
    },

    printResult() {
        this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style scoped>
.border-top-dark { border-top: 4px solid #343a40; }

/* === تنسيقات الشبكة والبوكس === */
.result-grid {
    display: grid;
    /* 5 أعمدة في الصف الواحد (مناسب جداً لـ A4 Portrait) */
    grid-template-columns: repeat(5, 1fr); 
    gap: 5px; /* مسافة صغيرة بين المربعات */
    margin-bottom: 20px;
}

.student-box {
    border: 1px solid #000;
    display: flex;
    /* justify-content: space-between; */
    align-items: center;
    font-weight: bold;
    background-color: #fff;
    height: 35px; /* ارتفاع ثابت */
    overflow: hidden;
}

.seat-num {
    width: 45%;
    height: 100%;
    background-color: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'Courier New', Courier, monospace;
    font-size: 1.1rem;
    border-left: 1px solid #fff;
}

.total-score {
    width: 55%;
    text-align: center;
    font-size: 1.2rem;
}

/* تنسيق الراسب */
.failed-box .total-score {
    background-color: #ddd; /* تظليل رمادي للراسب */
    color: #000; 
    text-decoration: underline; /* أو دائرة حسب الرغبة */
}

/* عناوين الفئات */
.category-title {
    border-bottom: 2px solid #000;
    padding: 5px;
    font-weight: bold;
    margin-bottom: 10px;
    display: inline-block;
    min-width: 200px;
    text-align: center;
    border-radius: 4px;
}

/* === تنسيقات الطباعة === */
@media print {
  @page {
    size: A4 portrait; /* طولي */
    margin: 10mm;
  }

  body * { visibility: hidden; }
  .no-print { display: none !important; }
  
  #printMe, #printMe * { visibility: visible; }
  #printMe { position: absolute; left: 0; top: 0; width: 100%; }

  .school-sheet { page-break-after: always; }
  .break-avoid { page-break-inside: avoid; }

  /* ضمان ظهور الخلفيات */
  .bg-dark, .seat-num, .bg-secondary, .bg-info, .failed-box .total-score {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
  }
}
</style>